import { IUser } from "@share/common-types";

export const ViewQuotesSharePermission = 'VIEWQUOTESSHARE';
export const ViewCondoSupplierPermission = 'SEECONDOSUPPLIER';
export const VieAllAccountBookingsPermission = 'VIEWALLACCOUNTBOOKINGS';
export const ReportIssuePermission = 'REPORTISSUE';
export const ViewManualBookingsPermission = 'VIEWMANUALBOOKINGS';

export const ALL_PERMISSIONS: string[] = [
  ViewQuotesSharePermission,
  ViewCondoSupplierPermission,
  ReportIssuePermission
];

export const HasPermission = (user: IUser | null, permission: string): boolean => {
  return !!user?.permissions && user?.permissions?.includes(permission);
}
